export function convertFiltersToParams(filters, mode = 'AND') {
  const newSearchParams = new URLSearchParams()

  // Group filters by field
  const groupedFilters = {}
  filters.forEach((filter) => {
    if (!groupedFilters[filter.field]) {
      groupedFilters[filter.field] = []
    }
    groupedFilters[filter.field].push(filter)
  })

  // Apply filters with index for duplicates
  // For regular filters: filter:field:operator=value
  // For duplicate filters (like multiple analysis filters): filter:field:operator:index=value
  Object.entries(groupedFilters).forEach(([, fieldFilters]) => {
    fieldFilters.forEach((filter, index) => {
      const paramKey = fieldFilters.length > 1
        ? `filter:${filter.field}:${filter.operator}:${index}`
        : `filter:${filter.field}:${filter.operator}`
      const paramValue = ['analysis', 'variables'].includes(filter.field) && typeof filter.value != 'string'
        ? JSON.stringify(filter.value)
        : filter.value
      newSearchParams.set(paramKey, paramValue)
    })
  })

  newSearchParams.set('mode', mode)

  return newSearchParams
}

export function convertParamsToFilters(searchParams) {
  const filters = []

  // Loop through all search params
  for (const [key, value] of searchParams.entries()) {
    if (!key.startsWith('filter:'))
      continue

    // Split the key to extract field, operator, and optional index
    // Format: filter:field:operator for regular filters
    // Format: filter:field:operator:index for duplicate filters (like multiple analysis filters)
    const keyParts = key.split(':')
    const field = keyParts[1]
    const operator = keyParts[2]
    // Index is optional - it may not exist for non-duplicate filters

    if (field && operator) {
      filters.push({
        field,
        operator,
        value,
      })
    }
  }

  return filters
}
